import { Injectable } from '@angular/core';
import { AppState } from '../app.state';
import { select, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, debounceTime, of, share, switchMap, withLatestFrom } from 'rxjs';
import * as SharedActions from '@states/shared/shared.actions';
import { ArchiveStatsActions } from '@states/archive-stats/archive-stats.action-types';
import { ArchiveStatsService } from '../../services/archive-stats.service';
import { UtilsService } from '../../edge/utils.service';

@Injectable()
export class ArchiveStatsEffects {

  public beforeGetArchiveStats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ArchiveStatsActions.beforeGetArchiveStats),
      switchMap(() => [
        ArchiveStatsActions.setListLoader({ loading: true }),
        ArchiveStatsActions.getArchiveStats(),
      ]),
      share(),
    ),
  );

  public getArchiveStats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ArchiveStatsActions.getArchiveStats),
      withLatestFrom(
        this.store$.pipe(select(state => state.archiveStatsState)),
      ),
      switchMap(([, { requestFilter, isLastPage, latestTs }]) => {
        if (!isLastPage) {
          return this.archiveStatsService
            .getArchiveStats(requestFilter, latestTs)
            .pipe(
              switchMap(res => {
                return [
                  ArchiveStatsActions.getArchiveStatsSuccess({ items: res }),
                  ArchiveStatsActions.setListLoader({ loading: false }),
                ];
              }),
              catchError(err => {
                const errMsg = this.utilsService.errMessage(err);
                return [
                  SharedActions.consoleMessage({ error: errMsg }),
                  ArchiveStatsActions.setListLoader({ loading: false }),
                  ArchiveStatsActions.getArchiveStatsFail(),
                ];
              }),
            );
        } else {
          return [
            SharedActions.doNothing(), 
            ArchiveStatsActions.setListLoader({ loading: false })
          ];
        }

      }),
      share(),
    ),
  );


  public filterTrigger$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        ArchiveStatsActions.setCalendarFilter,
        ArchiveStatsActions.setStatusFilter,
        ArchiveStatsActions.setOrgIdFilter,
      ),
      debounceTime(400),
      switchMap(() => [
        ArchiveStatsActions.setListLoader({ loading: true }),
        ArchiveStatsActions.resetEntities(),
        ArchiveStatsActions.beforeGetArchiveStats(),
      ]),
    ),
  );

  constructor(private store$: Store<AppState>,
              private actions$: Actions,
              private archiveStatsService: ArchiveStatsService,
              private utilsService: UtilsService) {
  }
}
